"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateContactCommunicationDetailsDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
const create_contact_communication_details_dto_1 = require("./create-contact-communication-details.dto");
class UpdateContactCommunicationDetailsDto {
}
exports.UpdateContactCommunicationDetailsDto = UpdateContactCommunicationDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "ID of the communication detail to update",
        example: 1,
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "ID must be an integer." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactCommunicationDetailsDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Contact ID associated with the contact details",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Contact ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactCommunicationDetailsDto.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Type of communication (email or phone)",
        example: "email",
        required: true,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Communication type is required." }),
    (0, class_validator_1.IsString)({ message: "Communication type must be a string." }),
    (0, class_validator_1.IsIn)(["email", "phone"], {
        message: "Communication type must be 'email' or 'phone'.",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateContactCommunicationDetailsDto.prototype, "communicationType", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Details of the communication (email address or phone number)",
        example: "john.doe@example.com",
        required: true,
    }),
    (0, class_validator_1.IsNotEmpty)({ message: "Communication details are required." }),
    (0, class_validator_1.IsString)({ message: "Communication details must be a string." }),
    (0, class_validator_1.MaxLength)(255, {
        message: "Communication details must not exceed 255 characters.",
    }),
    (0, class_validator_1.Validate)(create_contact_communication_details_dto_1.IsValidCommunicationDetails),
    tslib_1.__metadata("design:type", String)
], UpdateContactCommunicationDetailsDto.prototype, "communicationDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Indicates if this is the primary communication detail",
        example: false,
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsBoolean)({ message: "isPrimary must be a boolean value." }),
    tslib_1.__metadata("design:type", Boolean)
], UpdateContactCommunicationDetailsDto.prototype, "isPrimary", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "User who last updated the record",
        example: "admin",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Updated by must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactCommunicationDetailsDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Timestamp of the last update",
        example: "2025-04-02T12:34:56.789Z",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)({ message: "Updated At must be a string." }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], UpdateContactCommunicationDetailsDto.prototype, "updatedAt", void 0);
